import { EDomain } from '~/types/enum';

export const shouldUseNaniClubOidc = (): boolean =>
  window.location.origin.includes(EDomain.BOX3);

export const getNaniClubOidcAuthUrl = (): string => {
  const params = new URLSearchParams({
    client_id: import.meta.env.VITE_NANI_CLUB_OIDC_CLIENT_ID,
  });

  return `${import.meta.env.VITE_NANI_CLUB_API}/oidc/auth?${params.toString()}`;
};
